<template>
  <div class="zl-upload" :class="{'is-disabled': disabled}">
    <el-upload
      ref="upload"
      v-bind="$attrs"
      :action="action"
      list-type="picture-card"
      :before-upload="before"
      :on-success="success"
      :file-list="fileList"
      :before-remove="bRemove"
      :headers="headers"
      :data="params()"
      :on-change="change"
      :disabled="disabled"
    >
      <template slot="file" slot-scope="{ file }">
        <slot name="file" :file="file">
          <div class="zl-upload-file" @click="handleClickFile(file)">
            <img class="zl-upload-file-img" :src="getExtImg(file.name)">
            <div class="zl-upload-file-name">{{ file.name }}</div>
            <div v-if="!disabled" class="zl-upload-file-del" @click.stop="remove(file)">删除</div>
            <!-- <template v-if="!disabled">
              <el-progress
                v-if="file.status === 'uploading'"
                type="circle"
                :width="22"
                :stroke-width="2"
                :show-text="false"
                :percentage="parsePercentage(file.percentage)"
              />
              <div v-else class="zl-upload-file-del" @click.stop="remove(file)">删除</div>
            </template> -->
          </div>
        </slot>
      </template>

      <slot slot="trigger" name="trigger">
        <div class="zl-upload-trigger">
          选择文件
        </div>
      </slot>
    </el-upload>
  </div>
</template>

<script>
import { tableExport } from '@/utils'
import getExtImg from './ext'

function clickFile(file = {}) {
  if (!file.url) return
  const option = {
    url: file.url,
    baseURL: file.baseURL,
    name: file.name,
    data: file.data,
    suffix: file.suffix
  }
  tableExport(option)
}

export default {
  components: {
    // Upload
  },
  inject: {
    $page: {
      default: () => ({})
    }
  },
  props: {
    // eslint-disable-next-line
    value: {},
    data: {
      type: Object,
      default: () => ({})
    },
    getData: {
      type: Function,
      default: () => ({})
    },
    url: {
      type: String,
      default: ''
    },
    baseURL: {
      type: String,
      default: process.env.VUE_APP_BASE_API
    },
    disabled: {
      type: Boolean,
      default: false
    },
    beforeUpload: {
      type: Function,
      default: () => true
    },
    beforeRemove: {
      type: Function,
      default: () => true
    },
    onSuccess: {
      type: Function,
      default: () => undefined
    },
    clickFile: {
      type: Function,
      default: clickFile
    },
    onChange: {
      type: Function,
      default: () => undefined
    },
    // eslint-disable-next-line
    parse: Function
  },
  data() {
    return {
      fileList: []
    }
  },
  computed: {
    headers() {
      return {
        'Authentication-Info': this.$store.getters.token
      }
    },
    action() {
      return this.url ? `${this.baseURL}${this.url}` : 'not_upload'
    }
  },
  async created() {
    let list = []
    if (Array.isArray(this.value)) {
      list = [...this.value]
    }
    if (this.parse) {
      list = await this.parse(this.value)
    }
    this.fileList = list
  },
  methods: {
    // 获取文件类型的图片
    getExtImg(...rest) {
      return getExtImg(...rest)
    },
    // 上传进度
    parsePercentage(val) {
      return parseInt(val, 10)
    },
    // 上传参数携带
    params() {
      return this.getData(this.data)
    },
    // 删除之前
    bRemove(file, filelist) {
      return this.beforeRemove(file, filelist)
    },
    // 删除
    remove(file) {
      this.$refs.upload.handleRemove(file)
    },
    // 上传之前的调用
    before(file) {
      return this.beforeUpload(file, this.data)
    },
    success(...rest) {
      return this.onSuccess(...rest)
    },
    change(...rest) {
      this.onChange(...rest)
    },
    handleClickFile(file) {
      this.clickFile(file)
    }
  }
}
</script>

<style lang="scss" scoped>
.zl-upload {
  /deep/ {
    .el-upload--picture-card {
      height: 32px;
      line-height: 32px;
    }
    .el-upload-list--picture-card .el-upload-list__item {
      height: 32px;
      line-height: 32px;
      width: 220px;
    }
    .el-upload-list__item .el-progress {
      width: auto;
      position: relative;
      top: unset;
      left: unset;
      transform: none;
    }
  }

  &-file {
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    align-items: center;
    height: 32px;
    width: 220px;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      .zl-upload-file-del {
        visibility: visible;
      }
    }
  }
  &-file-img {
    height: 18px;
  }
  &-file-name {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 5px;
  }
  &-file-del {
    white-space: nowrap;
    visibility: hidden;
    &:hover {
      color: #008EE3;
    }
  }
}
.is-disabled {
  /deep/ {
    .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
